import { Group, Title, Stack, Text } from '@mantine/core'
import CircleText from '../../symbols/CircleText'

function InstructionsStep() {
  return (
    <Group w='80%' gap='10%'>
      <Title flex={3} visibleFrom='sm' size={42}>
        Welcome to Hidden Gemz! <br />
        Let's fill out your business profile
      </Title>
      <Title flex={3} hiddenFrom='sm' size={32} pb={24}>
        Welcome to Hidden Gemz! <br />
        Let's fill out your business profile
      </Title>
      <Stack flex={2}>
        <Group>
          <CircleText text='1' />
          <Title size='h2'>Create Your First Location</Title>
          <Text>Share some info like address, photos, and business hours</Text>
        </Group>
        <hr style={{ width: '100%' }} />
        <Group>
          <CircleText text='2' />
          <Title size='h2'>Banking Information</Title>
          <Text>
            Securely connect banking info to Stripe so that you can receive
            payments from advertisers
          </Text>
        </Group>
        <hr style={{ width: '100%' }} />

        <Group>
          <CircleText text='3' />
          <Title size='h2'>Setup Your First Screen</Title>
          <Text>
            Specify details about your screen including: a photo, size,
            location, and pricing
          </Text>
        </Group>
      </Stack>
    </Group>
  )
}

export default InstructionsStep
